import { render, staticRenderFns } from "./MenuDiaLog.vue?vue&type=template&id=3fcb1d11&scoped=true&"
import script from "./MenuDiaLog.vue?vue&type=script&lang=js&"
export * from "./MenuDiaLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb1d11",
  null
  
)

export default component.exports